// extracted by mini-css-extract-plugin
export default {"summaryItem":"summaryItem___opB4g","summaryValue":"summaryValue___brg_b","amount":"amount___CzEDN","tips":"tips___lszvc"};